import { message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updateAccountDetails } from "Sdk/Actions";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";

export const CustomTheme = ({ isCustomThemeOpen, setIsCustomThemeOpen }) => {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [selectedThemeId, setselectedThemeId] = useState(null);
  const userDetails = useSelector(getUserDetailsFromReducer);

  const themePalettes = [
    {
      id: 0,
      themecolor: {
        background: "#E6E6E6",
        text: "#333C4D",
        btnBg: "#ffffff",
        btnText: "#333C4D",
      },
    },
    {
      id: 1,
      themecolor: {
        background: "#16161E",
        text: "#FCFCFF",
        btnBg: "#ff9300",
        btnText: "#000000",
      },
    },
    {
      id: 2,
      themecolor: {
        background: "#FFFFFF",
        text: "#000000",
        btnBg: "#007BFF",
        btnText: "#FFFFFF",
      },
    },
    {
      id: 3,
      themecolor: {
        background: "#1A1A1A",
        text: "#F5F5F5",
        btnBg: "#FF5733",
        btnText: "#F5F5F5",
      },
    },
    {
      id: 4,
      themecolor: {
        background: "#F5F5DC",
        text: "#8B4513",
        btnBg: "#FFD700",
        btnText: "#8B4513",
      },
    },
    {
      id: 5,
      themecolor: {
        background: "#00008B",
        text: "#FFFFFF",
        btnBg: "#1E90FF",
        btnText: "#FFFFFF",
      },
    },
    {
      id: 6,
      themecolor: {
        background: "#2F4F4F",
        text: "#FFFFFF",
        btnBg: "#00CED1",
        btnText: "#FFFFFF",
      },
    },
    {
      id: 7,
      themecolor: {
        background: "#800000",
        text: "#FFFFFF",
        btnBg: "#FF4500",
        btnText: "#FFFFFF",
      },
    },
    {
      id: 8,
      themecolor: {
        background: "#4B0082",
        text: "#FFFFFF",
        btnBg: "#9400D3",
        btnText: "#FFFFFF",
      },
    },
    {
      id: 9,
      themecolor: {
        background: "#228B22",
        text: "#FFFFFF",
        btnBg: "#32CD32",
        btnText: "#FFFFFF",
      },
    },
  ];

  const handleUpdateCustomTheme = async () => {
    try {
      if (selectedTheme) {
        let customThemeStringified = JSON.stringify(selectedTheme);
        const userData = {
          username: userDetails.username,
          themeColor: customThemeStringified,
        };
        await updateAccountDetails(userData);
        message.success("Theme Updated Succesfully!");
      } else {
        console.log("selectedTheme not found");
      }
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    }
  };

  const handleThemeSelect = (id) => {
    const selectedPalette = themePalettes.find((palette) => palette.id === id);
    if (selectedPalette) {
      setSelectedTheme(selectedPalette.themecolor);
      setselectedThemeId(id);
    } else {
      console.error("Theme not found for ID:", id);
    }
  };

  useEffect(() => {
    handleUpdateCustomTheme();
  }, [selectedTheme]);

  return (
    <Modal
      open={isCustomThemeOpen}
      onCancel={() => setIsCustomThemeOpen(false)}
      footer={null}
      title="Select Theme"
    >
      <div className="overflow-x-auto p-5">
        <div className="grid gap-4 md:grid-cols-4 grid-cols-2">
          {themePalettes.map((palette) => (
            <div
              key={palette.id}
              className={`p-2 border-2 rounded-lg cursor-pointer ${
                selectedThemeId === palette.id
                  ? "border-blue-500"
                  : "border-gray-300"
              }`}
              onClick={() => handleThemeSelect(palette.id)}
            >
              <div className="flex rounded-md w-full overflow-hidden">
                <div
                  className="h-10 w-full"
                  style={{ backgroundColor: palette.themecolor.background }}
                ></div>
                <div
                  className="h-10 w-full"
                  style={{ backgroundColor: palette.themecolor.text }}
                ></div>
                <div
                  className="h-10 w-full"
                  style={{ backgroundColor: palette.themecolor["btnBg"] }}
                ></div>
                <div
                  className="h-10 w-full"
                  style={{ backgroundColor: palette.themecolor["btnText"] }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
